import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { FormControl, Validators } from "@angular/forms";
import { DatePipe } from "@angular/common";
import { Subject } from 'rxjs';
import { PlanShipmentService } from 'src/app/services/plan-shipment.service';
import { takeUntil } from 'rxjs/operators';
import { DivisibleToEvenValidator } from "src/app/directives/divisible-to-even-validator";
import { ShipyardService } from "../shipyard.service";
import { AddSkuToShipmentComponent } from "../shipments-list/add-sku-to-shipment/add-sku-to-shipment.component";
import { ConfirmShipmentPayload } from './../../../models/shipyard.model';
import { ShipmentPlan } from "../../../models/shipyard.model";
import { HeaderService } from "../../../components/header/header.service";
import {SnackbarComponent} from '../../../components/snackbar/snackbar.component';
import { InventoryService } from "src/app/services/inventory.service";
import { CommonDropdownComponent } from "src/app/components/dialogs/common-dropdown/common-dropdown.component";
import { AuthService } from "src/app/services/auth.service";
import { LoginModel } from "src/app/models/login.model";

@Component({
  selector: "app-plan-shipment-sku",
  templateUrl: "./plan-shipment-sku.component.html",
  styleUrls: ["./plan-shipment-sku.component.scss"],
  providers:[DatePipe]
})
export class PlanShipmentSkuComponent implements OnInit, OnDestroy, OnChanges {
  percentage: number=0;
  errorMessage: string;
  @Input() data: any;
  @Input() skuToAddToShipment: any;
  @Input() formvalue: any;
  @Input() selectedFbaTypeShipment;
  @Input() isCaseQty;
  @Input() isWalmart=false;
  @Input() isAdvancePlanning = true;
  @Output() itemSelectedEvent: EventEmitter<any> = new EventEmitter();
  @Output() createShipmentEvent: EventEmitter<any> = new EventEmitter();
  @Output() onChangeSelectionEvent: EventEmitter<any> = new EventEmitter();
  @Output() onQtyChange: EventEmitter<any> = new EventEmitter();
  @Output() updateCaseQty : EventEmitter<any> = new EventEmitter();
  @Output() updateType : EventEmitter<any> = new EventEmitter();
  @Input() isPrepAMZ: 'true' | 'false' = 'false';
  expand: boolean = true;
  account;
  qtyInput: FormControl;
  caseQtyInput: FormControl;
  selectedShipment: any;
  selectedIndex: any;
  spinLoader: boolean = false;
  isPlanDisabled: boolean = true;
  isLoading: boolean = false;
  currentDate: string;
  totalPlans: number = 1
  isPlanAll: boolean = false;
  private destroy$ = new Subject<void>();
  isValidQuantity: boolean = false;
  isValidCaseQuantity: boolean = false;
  userInfo:LoginModel;
  cases: FormControl;

  constructor(
    public dialogRef: MatDialogRef<AddSkuToShipmentComponent>,
    private shipyardService: ShipyardService,
    public headerService: HeaderService,
    private snackBar: MatSnackBar,
    public datepipe: DatePipe,
    private planShipmentService: PlanShipmentService,
    private dialog:MatDialog,
    private inventoryService: InventoryService,
    private authService:AuthService
  ) {
    this.headerService.accountsSelected.pipe(takeUntil(this.destroy$)).subscribe((e) => (this.account = e));
    // this.shipyardService.planProgress.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
    //   if (res) {
    //     if (!res.showProgess) this.data.spinLoader = false;
    //   }
    // });

    this.shipyardService.isPlanAll.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      if (res) {
        if (this.data?.sku.Sku == res.sku.Sku && !res.isPlanned) {
          this.toggleTable(res)
          res.isPlanned = true;
        }
      }
    })

    this.authService.userInfo$.pipe(takeUntil(this.destroy$)).subscribe((userInfo) => {
      this.userInfo = userInfo;      
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
    this.shipyardService.planProgress.next(null)
  }

  ngOnChanges(changes: SimpleChanges): void {
    const casesVal=(this.data.qty / (this.data.sku.CaseQty || 1));
    if(!this.data.sku.CaseQty){
      this.caseQtyInput?.setValue(this.data.qty);
      this.cases?.setValue(1);  
    } else{
      this.caseQtyInput?.setValue((Number.isInteger(casesVal) ? this.data.sku.CaseQty : this.data.qty));
      this.cases?.setValue((Number.isInteger(casesVal) ? casesVal : 1)  || 0);        
    }  
    this.updateQuantities(this.data.sku.CaseQty);
  }

  ngOnInit(): void {
    this.isValidQuantity = !this.data.qty;
    this.isValidCaseQuantity = !this.data.qty;
    if (this.data.shipmentPlan && this.data.shipmentPlan?.length != 0) {
      this.data.showTable = true;
    }
    if(this.isAdvancePlanning){
      this.qtyInput = new FormControl(this.data.qty,!this.isWalmart ? [
        Validators.required,
        Validators.max(this.data.maxQty),
        Validators.min(this.data.minQty || 1),

      ] : null);
    } else {
      this.qtyInput = new FormControl(this.data.qty, [
        Validators.required,  Validators.min( 1)    
      ]);
    }

    const casesVal=(this.data.qty / (this.data.sku.CaseQty || 1));

      this.caseQtyInput = new FormControl(this.data.sku.CaseQty && Number.isInteger(casesVal) ? this.data.sku.CaseQty : this.data.qty,!this.isWalmart ? [
        Validators.required,
        Validators.max(150)        
      ] : null);

      
      this.cases = new FormControl(this.data.sku.CaseQty && Number.isInteger(casesVal) ? casesVal : 1, !this.isWalmart ? [
        Validators.required,     
        Validators.min(this.data.minQty || 1),
      ] : null);

    this.shipyardService.isWarehouse.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.isPlanDisabled = !res
    })
    this.casesChanged();
  }

  mergeShipment(shipmentPlan, shipmentPlanHeaderId?) {
    this.isLoading = true;
    const skus = this.selectedFbaTypeShipment.map((item) => {
      return {
        sku: item.sku.Sku,
        qty: item.qty,
        accountSkuId:item.sku.AccountSkuId
      };
    });

    const editShipmentPayload = {
      skus,
      shipmentHeaderId: null,
      appendQty: false,
    };

    const confirmShipmentPayload: ConfirmShipmentPayload = {
      shipmentPlanHeaderId: shipmentPlanHeaderId,
      details: shipmentPlan.map(plan => {
        return {
          shipmentId: plan.shipmentId,
          shipmentName: plan.shipmentName
        }
      })
    }

    this.shipyardService
      .ConfirmShipment(
        confirmShipmentPayload
      ).pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (e) => {
          let shipmentHeaderId: number;
          if (this.selectedIndex) {
            shipmentHeaderId = e[this.selectedIndex]
          } else {
            shipmentHeaderId = e[0];
          };

          editShipmentPayload.shipmentHeaderId = shipmentHeaderId;
          this.shipyardService.EditShipmentSku(editShipmentPayload).pipe(takeUntil(this.destroy$)).subscribe({
            next: (e: any) => {
              this.data.showTable = false;
              this.data.planned = true;
            },
           error: (err) => {
              this.snackBar.openFromComponent(SnackbarComponent,
                  {
                    duration: 3000,
                    horizontalPosition: 'center',
                    data: {
                      title: err.error.error[0],
                      action: 'Dismiss',
                      type: 'error',
                    },
                  }
              );
            }
         });
          this.createShipmentEvent.emit(shipmentHeaderId);
        },
     error: (err) => {
          this.snackBar.openFromComponent(SnackbarComponent,
              {
                duration: 3000,
                horizontalPosition: 'center',
                data: {
                  title: err.error.error[0],
                  action: 'Dismiss',
                  type: 'error',
                },
              }
          );
        }
     });
  }


  planShipment() {    
    this.data.spinLoader = true;
    const skusToAddToShipment = {
      sku: this.data.sku.Sku ? this.data.sku.Sku : this.data.sku,
      qty: this.qtyInput.value,
      caseQty: this.isCaseQty ? this.cases.value : null,
    };

    const form = this.formvalue.getRawValue();

    const formValue = {
      account: this.account[0],
       shipmentType: this.shipyardService.getShipmentTypeId(this.selectedFbaTypeShipment.FbaType),
      fromWareHouseId: form.fromWareHouseId.id,
      skus: [skusToAddToShipment],
      isPrepAMZ: this.isPrepAMZ === 'true' ? true : false,
      
    };

    this.planShipmentService.planShip('Post', formValue, null).
      pipe(takeUntil(this.destroy$)).
    subscribe({
      next: (e: { errors: any[]; shipmentPlans: ShipmentPlan[] }) => {
        if (e.shipmentPlans?.length != 0) {
          this.data.shipmentPlan = e.shipmentPlans;
          this.data.hasError = false;
          this.getShipmentName();
          this.data.planned = true;
          this.data.showTable = true;
          if(this.data.shipmentPlan?.length > 1){
            this.data.multiPlanHeaderRowData={
              plans:this.data.shipmentPlan?.length,
              qty:this.data.qty
            };
          }   
        this.calculateProgress();
          
        } else {
          this.showError(e.errors[0].reason, e.errors.map((e) => `${e.reason}`).join("A"));

        }
      },
       error: (err) => {
          const errorMessage = err && err.error ? err.error["error"][0] : 'Error planning shipment';
          this.showError(errorMessage, errorMessage);
        }
     });
  }

  showError(errorMessage, toastMessage) {
    this.data.hasError = true
    this.data.errorMessage = errorMessage;
    this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 10000,
          horizontalPosition: 'center',
          data: {
            title: toastMessage,
            action: 'Dismiss',
            type: 'error',
          },
        }
    );
    this.calculateProgress();
  }

  calculateProgress() {
    const isShowProgress = this.shipyardService.planCount === this.totalPlans ? false : true;
    this.percentage = (this.shipyardService.planCount * 100) / this.totalPlans;
    this.shipyardService.planProgress.next({ showProgess: isShowProgress, percentage: this.percentage, isPlanAll: this.isPlanAll })
    this.shipyardService.planCount == this.totalPlans ? this.shipyardService.planCount = 1 : this.shipyardService.planCount += 1;
    this.data.spinLoader = false;
  }

  getShipmentName() {
    let i: number = 1;
    this.data.shipmentPlan?.forEach(element => {
      let date = new Date();
      this.currentDate = this.datepipe.transform(date, 'MM/dd/yy hh:mm:ss a');
      element.shipmentName = "FBA-(" + this.currentDate + ")-" + i;
      i++;
    });
  }

  toggleTable(res?) {
    this.totalPlans = res ? res.totalCount : 1;
    this.isPlanAll = res ? true : false;
    this.data.qty = this.qtyInput.value;
    this.data.caseQty = this.caseQtyInput.value;
    this.data.showTable = false;
    this.data.hasError = false;
    this.data.errorMessage = '';
    this.data.shipmentPlan = [];
    this.shipyardService.planProgress.next({ showProgess: this.isPlanAll, isPlanAll: this.isPlanAll, percentage: this.percentage })
    this.planShipment();
  }

  close() {
    this.dialogRef.close();
  }

  itemSelected(sku: any) {
    this.itemSelectedEvent.emit(sku);
  }

  qtyChanged(event: any) {
    if ((event.target.value >= 1 && this.caseQtyInput.value <= 150) && event.target.value >= this.caseQtyInput.value) {
      this.isValidQuantity = false;
      this.data.planned = false;
    } else {
      this.isValidQuantity = true;
    }
    this.selectedFbaTypeShipment.forEach((res, index) => {
      if (res.sku.Sku == this.data.sku.Sku) {            
        this.selectedFbaTypeShipment[index].totalQty = (Number(res.sku.CaseQty) * event.target.value)         
        this.selectedFbaTypeShipment[index].qty = (Number(res.sku.CaseQty) * event.target.value)         
      }     
    })
    this.updateQuantity(event.target.value);
  }

  casesChanged() {
    const cases = this.cases.value;
    const caseQty = this.caseQtyInput.value;
    this.qtyInput.setValue(Number(cases) * caseQty);
    const totalQty = this.qtyInput.value;
    this.selectedFbaTypeShipment.qty = 0;
    this.selectedFbaTypeShipment.forEach((res, index) => {
      if (res.sku.Sku == this.data.sku.Sku) {            
        this.selectedFbaTypeShipment[index].totalQty = (Number(cases) * caseQty)         
        this.selectedFbaTypeShipment[index].qty = (Number(cases) * caseQty)         
      }     
    })
    const totalIsDevisable = totalQty % caseQty === 0;
    if (totalIsDevisable && caseQty >= 1 && caseQty <= 150)   {
      this.isValidCaseQuantity = true;
    } else {
      this.isValidCaseQuantity = false;
      this.data.planned = false;
    }
   this.updateQuantities(caseQty);
  }

  updateQuantities(qty){
    const sku :any = {
      Sku : this.data.sku.Sku,
      qty: qty
    }
    this.updateCaseQty.emit(sku);
   }

  updateQuantity(qty) {
    this.selectedFbaTypeShipment.forEach((res, index) => {
      if (res.sku.Sku == this.data.sku.Sku) {
        this.selectedFbaTypeShipment.qty -= this.selectedFbaTypeShipment[index].qty;
        this.selectedFbaTypeShipment.qty += Number(qty);
        this.selectedFbaTypeShipment[index].qty = Number(qty);
        this.onQtyChange.emit({sku: this.data.sku.Sku, qty: qty})
      }
    });
    this.onQtyChange.emit(this.data)
  }

  selectShipment(plan, index) {
    if (this.selectedIndex === index) {
      this.selectedShipment = "";
      this.selectedIndex = "";
    } else {
      this.selectedShipment = plan;
      this.selectedIndex = index;
    }
  }

  expandDetails() {
    this.expand = !this.expand;
    this.selectedShipment = "";
  }

  stopPropagation(e: MouseEvent) {
    e.stopPropagation();
  }

  onChangeSelection(){
    this.onChangeSelectionEvent.emit(this.data)
  }

  updateFbaType(){
    this.dialog
    .open(CommonDropdownComponent, {
      width: "500px",
      data: {
        title: "Update FBA Type",
        selectedType:this.data.sku.FbaType,
        options:this.shipyardService.getAllShipmentTypes(),
        confirmationButton: "Confirm",
        callBackFn: (dialogRef, actions,fbaType) => {
          actions[1].spin = true; 
          let payload = {
            skus: [this.data.sku.Sku],
            isOversized: fbaType[0].id,
            account: this.data.sku.Account,
          };
          this.inventoryService.updateIsoversized(payload).pipe(takeUntil(this.destroy$)).subscribe({
            next: () => {
            actions[1].spin = false;
            this.updateType.emit({sku: this.data.sku,qty:this.data.qty,selectedFbaType:fbaType[0].name});
            if (dialogRef) dialogRef.close();
            this.snackBar.openFromComponent(SnackbarComponent,
                {
                  duration: 3000,
                  horizontalPosition: 'center',
                  data: {
                    title: 'Type updated Successfully',
                    action: 'Dismiss',
                    type: 'success',
                  },
                }
            );
          },
           error: (err) => {
            actions[1].spin = false;
            this.snackBar.openFromComponent(SnackbarComponent,
              {
                duration: 3000,
                horizontalPosition: 'center',
                data: {
                  title: err?.error?.error[0],
                  action: 'Dismiss',
                  type: 'error',
                },
              }
          );
           }
          });          
        },
      },
    })
    .afterClosed()
    .subscribe((res) => {});
  }
}
